export const CONSTANTS = {
  SCREEN_GROUP: 'order',
  LIST_ALL: 'list-order-all',
  LIST_ORDER_ITEM_STATUS: 'list-order-item-status',
  LIST_ORDER_PRIORITY: 'list-order-priority',
  LIST_ORDER_STATUS: 'list-order-status',
  LIST_ORDER_TYPE: 'list-order-type',
  REQUEST_ORDER_DUPLICATE_CHECK: 'request-order-duplicate-check',
  REQUEST_ORDER_UPDATE_ROW: 'request-order-update-row',
  REQUEST_ORDER_DOWNLOAD_ATTACHMENT: 'request-order-download-attachment',
  REQUEST_ORDER_CANCEL_ORDER: 'request-order-cancel-order',
  REQUEST_ORDER_LOCK_ORDER: 'request-order-lock-order',
  REQUEST_ORDER_CREATE: 'request-order-create',
  REQUEST_ORDER_ADD_ITEM: 'request-order-add-item',
  REQUEST_ORDER_UPDATE_ITEM: 'request-order-update-item',
  REQUEST_ORDER_DELETE_ITEM: 'request-order-delete-item',
  GRID_ORDER_INQUIRY: 'grid-order-inquiry',
  GRID_ORDER_INQUIRY_SHIPPING_DETAIL: 'grid-order-inquiry-shipping-detail',
  GRID_ORDER_INQUIRY_ATTACHMENT: 'grid-order-inquiry-attachment',
  GRID_ORDER_INQUIRY_DETAIL: 'grid-order-inquiry-detail',
  GRID_ORDER_INQUIRY_DETAIL_ITEM_LOOKUP: 'grid-order-inquiry-detail-item-lookup',
  GRID_ORDER_INQUIRY_DETAIL_ITEM_INVENTORY: 'grid-order-inquiry-detail-item-inventory',
  DIALOG_ORDER_UPDATE_ITEM: 'dialog-order-update-item',
  WEIGHT: true,
  UOM: false,
} as const;
